import { ReviewType } from 'api/clients/InformalFeedbackRequestsClient'
import { ReviewType as ReviewsWizardReviewType } from 'components/ReviewsWizard/types'
import Styles from './ReviewTypeIcon.module.scss'
import {
  Approval as Approval16,
  ReadReceipt as ReadReceipt16,
  Review as Review16,
  Suggest as Suggest16,
} from 'almanac-ui/icons/16'
import {
  Approval as Approval24,
  ReadReceipt as ReadReceipt24,
  Review as Review24,
  Suggest as Suggest24,
} from 'almanac-ui/icons/24'

export interface ReviewTypeIconProps {
  reviewType: ReviewType | ReviewsWizardReviewType
  size?: 'sm' | 'md'
}

export const ReviewTypeIcon = ({ reviewType, size = 'md' }: ReviewTypeIconProps) => {
  if (size === 'sm') {
    switch (reviewType) {
      case ReviewType.Approval:
      case ReviewType.PrivateApproval:
      case ReviewsWizardReviewType.APPROVAL:
        return (
          <div role="img" title="Approval Icon" className={Styles.iconContainer}>
            <Approval16 />
          </div>
        )
      case ReviewType.Suggestion:
        return (
          <div role="img" title="Suggestion Icon" className={Styles.iconContainer}>
            <Suggest16 />
          </div>
        )
      case ReviewType.ReadReceipt:
      case ReviewsWizardReviewType.READ_RECEIPTS:
        return (
          <div role="img" title="ReadReceipt Icon" className={Styles.iconContainer}>
            <ReadReceipt16 />
          </div>
        )
      default:
        return (
          <div role="img" title="Review Icon" className={Styles.iconContainer}>
            <Review16 />
          </div>
        )
    }
  }

  switch (reviewType) {
    case ReviewType.Approval:
    case ReviewType.PrivateApproval:
    case ReviewsWizardReviewType.APPROVAL:
      return (
        <div role="img" title="Approval Icon" className={Styles.iconContainer}>
          <Approval24 />
        </div>
      )
    case ReviewType.Suggestion:
      return (
        <div role="img" title="Suggestion Icon" className={Styles.iconContainer}>
          <Suggest24 />
        </div>
      )
    case ReviewType.ReadReceipt:
    case ReviewsWizardReviewType.READ_RECEIPTS:
      return (
        <div role="img" title="ReadReceipt Icon" className={Styles.iconContainer}>
          <ReadReceipt24 />
        </div>
      )
    default:
      return (
        <div role="img" title="Review Icon" className={Styles.iconContainer}>
          <Review24 />
        </div>
      )
  }
}
